export const VAI_TRO = {
  KE_TOAN: 'Accountant',
  DIEU_HANH: 'Operating',
  KINH_DOANH: 'Sale',
  CSKH: 'CustomerService',
  KY_THUAT: 'Technician',
  QUAN_LY_CHI_NHANH: 'BranchManager',
  ADMIN: 'Admin',
  ROOT: 'Root',
  KHO: 'Warehouse'
};

export const LOAI_DON = {
  HANG_GUI: 1,
  LAP_MOI: 2,
  THU_PHI: 3,
  SUA_CHUA: 4,
  BAO_HANH: 5,
  THU_DOI: 6,
  NANG_CAP: 7,
  THAO_LAP_LAI: 8,
  DL_LAP_GIUM: 9, // Đại lý lắp dùm
  LAP_GIUM_DL: 10, // Lắp dùm đại lý
  THU_NO: 11,
  CHUA_XAC_DINH_12: 12
};

const SUA_CHUA_BAO_HANH = [LOAI_DON.SUA_CHUA, LOAI_DON.BAO_HANH];

export const LOAI_TIEN = {
  GIA_BAN_SP: 'giaBanSp',
  PHI_VA_CONG: 'phiVaCong',
  TIEN_THANH_TOAN: 'tienThanhToan',
  TIEN_THUC_THU: 'tienThucThu'
};

export const HINH_THUC_THANH_TOAN = {
  TIEN_MAT: 'Tiền mặt',
  CHUYEN_KHOAN: 'Chuyển khoản',
  NO: 'Nợ'
};

export const HIEN_THI = {
  HIEN: 'HIEN',
  AN: 'AN',
  VE_KHONG: 'VE_KHONG'
};

const TAT_CA_LOAI_TIEN = Object.values(LOAI_TIEN);

// ---------------------------------------------------------------------------
// 2. Cấu hình trường tiền áp dụng cho từng loại đơn
// ---------------------------------------------------------------------------

const LOAI_TIEN_THEO_LOAI_DON = {
  [LOAI_DON.THU_NO]: [LOAI_TIEN.TIEN_THANH_TOAN, LOAI_TIEN.TIEN_THUC_THU]
};

function laySoLoaiTienApDung(loaiDon: any): any {
  return LOAI_TIEN_THEO_LOAI_DON[loaiDon] ?? TAT_CA_LOAI_TIEN;
}

// ---------------------------------------------------------------------------
// 3. MA TRẬN QUYỀN XEM
// ---------------------------------------------------------------------------

const MA_TRAN_QUYEN_XEM_THEO_KEY_ORDER: any = {
  // Đơn thu nợ
  // Thu nợ (Chỉ có 2 loại tiền là Tiền thanh toán và Tiền thực thu)
  [LOAI_DON.THU_NO]: {
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN, // Điều chỉnh theo nghiệp vụ của bạn
      [VAI_TRO.KINH_DOANH]: HIEN_THI.AN, // Điều chỉnh theo nghiệp vụ của bạn
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  },
  // Lắp mới
  [LOAI_DON.LAP_MOI]: {
    [LOAI_TIEN.GIA_BAN_SP]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.PHI_VA_CONG]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN, // Đã sửa theo CSV: Có
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN, // Đã sửa theo CSV: Có
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  },
  // Hàng gửi
  [LOAI_DON.HANG_GUI]: {
    [LOAI_TIEN.GIA_BAN_SP]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.PHI_VA_CONG]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  },
  // Tháo - Lắp Lại
  [LOAI_DON.THAO_LAP_LAI]: {
    [LOAI_TIEN.GIA_BAN_SP]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.PHI_VA_CONG]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  },
  // Lắp dùm đại lý
  [LOAI_DON.LAP_GIUM_DL]: {
    [LOAI_TIEN.GIA_BAN_SP]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.PHI_VA_CONG]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  },
  // Đại lý lắp dùm (Duy nhất đơn này Điều hành/Kỹ thuật BỊ ẨN CẢ 4 LOẠI TIỀN)
  [LOAI_DON.DL_LAP_GIUM]: {
    [LOAI_TIEN.GIA_BAN_SP]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.PHI_VA_CONG]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  },
  // Thu Phí
  [LOAI_DON.THU_PHI]: {
    [LOAI_TIEN.GIA_BAN_SP]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.PHI_VA_CONG]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  },
  // Nâng cấp
  [LOAI_DON.NANG_CAP]: {
    [LOAI_TIEN.GIA_BAN_SP]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.PHI_VA_CONG]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.HIEN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  },
  // Thu đổi
  [LOAI_DON.THU_DOI]: {
    [LOAI_TIEN.GIA_BAN_SP]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.PHI_VA_CONG]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THANH_TOAN]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN, // Đã sửa theo CSV
      [VAI_TRO.KHO]: HIEN_THI.AN
    },
    [LOAI_TIEN.TIEN_THUC_THU]: {
      [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
      [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
      [VAI_TRO.CSKH]: HIEN_THI.AN,
      [VAI_TRO.KINH_DOANH]: HIEN_THI.HIEN,
      [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
      [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
      [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
      [VAI_TRO.KHO]: HIEN_THI.AN
    }
  }
};

// Sửa chữa (4) & Bảo hành (5)
const KHOI_SUA_CHUA_BAO_HANH = {
  [LOAI_TIEN.GIA_BAN_SP]: {
    [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
    [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
    [VAI_TRO.CSKH]: HIEN_THI.HIEN,
    [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
    [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
    [VAI_TRO.DIEU_HANH]: HIEN_THI.AN,
    [VAI_TRO.KY_THUAT]: HIEN_THI.AN,
    [VAI_TRO.KHO]: HIEN_THI.AN
  },
  [LOAI_TIEN.PHI_VA_CONG]: {
    [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
    [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
    [VAI_TRO.CSKH]: HIEN_THI.HIEN,
    [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
    [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
    [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
    [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
    [VAI_TRO.KHO]: HIEN_THI.AN
  },
  [LOAI_TIEN.TIEN_THANH_TOAN]: {
    [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
    [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
    [VAI_TRO.CSKH]: HIEN_THI.HIEN,
    [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
    [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
    [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN, // Đã sửa theo CSV
    [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN, // Đã sửa theo CSV
    [VAI_TRO.KHO]: HIEN_THI.AN
  },
  [LOAI_TIEN.TIEN_THUC_THU]: {
    [VAI_TRO.ADMIN]: HIEN_THI.HIEN,
    [VAI_TRO.QUAN_LY_CHI_NHANH]: HIEN_THI.HIEN,
    [VAI_TRO.CSKH]: HIEN_THI.HIEN,
    [VAI_TRO.KINH_DOANH]: HIEN_THI.AN,
    [VAI_TRO.KE_TOAN]: HIEN_THI.HIEN,
    [VAI_TRO.DIEU_HANH]: HIEN_THI.HIEN,
    [VAI_TRO.KY_THUAT]: HIEN_THI.HIEN,
    [VAI_TRO.KHO]: HIEN_THI.AN
  }
};
SUA_CHUA_BAO_HANH.forEach(loaiDon => {
  MA_TRAN_QUYEN_XEM_THEO_KEY_ORDER[loaiDon] = KHOI_SUA_CHUA_BAO_HANH;
});

const MA_TRAN_QUYEN_XEM = MA_TRAN_QUYEN_XEM_THEO_KEY_ORDER;

// ---------------------------------------------------------------------------
// 3b. Rule dự phòng
// ---------------------------------------------------------------------------

const VAI_TRO_LUON_XEM_TOAN_BO = [VAI_TRO.ADMIN, VAI_TRO.ROOT, VAI_TRO.QUAN_LY_CHI_NHANH, VAI_TRO.KE_TOAN];

function layQuyenDuPhong(vaiTro: any): any {
  if (VAI_TRO_LUON_XEM_TOAN_BO.includes(vaiTro)) return HIEN_THI.HIEN;
  return HIEN_THI.AN;
}

// ---------------------------------------------------------------------------
// 4. Ngoại lệ theo HÌNH THỨC THANH TOÁN (Ghi đè MA_TRAN_QUYEN_XEM)
// ---------------------------------------------------------------------------
// Dựa theo file CSV, với hình thức "Nợ", Điều hành & Kỹ thuật BỊ ẨN Tiền thanh toán
// (trong khi Tiền mặt & Chuyển khoản được phép xem).

const NGOAI_LE_THEO_HTTT: any = {
  [VAI_TRO.DIEU_HANH]: {},
  [VAI_TRO.KY_THUAT]: {}
};

// Cấu hình ngoại lệ này cho tất cả các đơn mà DH/KT thông thường được xem Tiền thanh toán
// (Trừ đơn DL_LAP_GIUM đã bị ẩn từ gốc).
const LOAI_DON_AN_TT_KHI_NO = [
  LOAI_DON.HANG_GUI,
  LOAI_DON.LAP_MOI,
  LOAI_DON.THU_PHI,
  LOAI_DON.SUA_CHUA,
  LOAI_DON.BAO_HANH,
  LOAI_DON.THU_DOI,
  LOAI_DON.NANG_CAP,
  LOAI_DON.THAO_LAP_LAI,
  LOAI_DON.LAP_GIUM_DL
];

[VAI_TRO.DIEU_HANH, VAI_TRO.KY_THUAT].forEach(vaiTro => {
  LOAI_DON_AN_TT_KHI_NO.forEach(loaiDon => {
    NGOAI_LE_THEO_HTTT[vaiTro][loaiDon] = {
      [HINH_THUC_THANH_TOAN.NO]: {
        [LOAI_TIEN.TIEN_THANH_TOAN]: HIEN_THI.AN
      }
    };
  });
});

// ---------------------------------------------------------------------------
// 5. Quyền tạo đơn
// ---------------------------------------------------------------------------

export const QUYEN_TAO_DON = {
  [VAI_TRO.KINH_DOANH]: [
    LOAI_DON.LAP_MOI,
    LOAI_DON.HANG_GUI,
    LOAI_DON.THAO_LAP_LAI,
    LOAI_DON.DL_LAP_GIUM,
    LOAI_DON.LAP_GIUM_DL,
    LOAI_DON.NANG_CAP,
    LOAI_DON.THU_DOI
  ],
  [VAI_TRO.CSKH]: [
    LOAI_DON.HANG_GUI,
    LOAI_DON.THAO_LAP_LAI,
    LOAI_DON.SUA_CHUA,
    LOAI_DON.BAO_HANH,
    LOAI_DON.THU_PHI,
    LOAI_DON.NANG_CAP
  ]
};

// ---------------------------------------------------------------------------
// 6. Logic xử lý
// ---------------------------------------------------------------------------

export function layQuyenXemTien(vaiTro: any, loaiDon: any, loaiTien: any, hinhThucThanhToan?: any): any {
  if (!laySoLoaiTienApDung(loaiDon).includes(loaiTien)) return null;

  const ngoaiLeHTTT = hinhThucThanhToan
    ? NGOAI_LE_THEO_HTTT[vaiTro]?.[loaiDon]?.[hinhThucThanhToan]?.[loaiTien]
    : undefined;
  if (ngoaiLeHTTT) return ngoaiLeHTTT;

  const oTrongMaTran = MA_TRAN_QUYEN_XEM[loaiDon]?.[loaiTien]?.[vaiTro];

  if (oTrongMaTran) return oTrongMaTran;

  return layQuyenDuPhong(vaiTro);
}

export function layQuyenXemTienDonHang(vaiTro: any, loaiDon: any, hinhThucThanhToan?: any): any {
  return laySoLoaiTienApDung(loaiDon).reduce((ket_qua, loaiTien) => {
    ket_qua[loaiTien] = layQuyenXemTien(vaiTro, loaiDon, loaiTien, hinhThucThanhToan);
    return ket_qua;
  }, {});
}

export function apDungQuyenXemTien(donHang: any, vaiTro: any, loaiDon: any, hinhThucThanhToan?: any): any {
  const quyenXem = layQuyenXemTienDonHang(vaiTro, loaiDon, hinhThucThanhToan);
  const ketQua = { ...donHang };
  laySoLoaiTienApDung(loaiDon).forEach(loaiTien => {
    const trangThai = quyenXem[loaiTien];
    if (trangThai === HIEN_THI.AN) delete ketQua[loaiTien];
    else if (trangThai === HIEN_THI.VE_KHONG) ketQua[loaiTien] = 0;
  });
  return ketQua;
}

export function layGiaTriTienHienThi(
  giaTriGoc: any,
  vaiTro: any,
  loaiDon: any,
  loaiTien: any,
  hinhThucThanhToan?: any
): any {
  const trangThai = layQuyenXemTien(vaiTro, loaiDon, loaiTien, hinhThucThanhToan);

  if (trangThai === HIEN_THI.AN || trangThai === null) return null;
  if (trangThai === HIEN_THI.VE_KHONG) return 0;
  return giaTriGoc;
}
